// extracted by mini-css-extract-plugin
module.exports = {"marker":"MarkerIcon_marker__2MWYF","signMarker":"MarkerIcon_signMarker__baQu4","multiple":"MarkerIcon_multiple__2ww8p","text":"MarkerIcon_text__1LbX3"};